module.exports = __webpack_public_path__ + "img/user-octagon.4ff7e685.svg";